import useAxiosPrivate from './useAxiosPrivate'

const useApi = () => {
    const axiosPrivate = useAxiosPrivate()

    const getMe = async (resource) => {
        //console.log('Get me Call starting...')
        const controller = new AbortController();
        try {
            const url = `api/${resource}`
            //console.log('<GET ME> URL Called:', url)
            const response = await axiosPrivate.get(url, {
                signal: controller.signal
            })
            
            return response.data
        } catch (err) {
            controller.abort()
            return (err.response)
        }
    }

    const getMeStream = async (entity) => {
        const controller = new AbortController();

        try {
            const url = `api/${entity}`;
            const response = await axiosPrivate.get(url, {
                signal: controller.signal,
                responseType: 'blob', // Set responseType to 'stream' for handling streams
            });

            if (response.status === 500) {
                return { error: 'File doesn\'t exist anymore'}
            }

            const file = new File([response.data], 'logo.png', { type: response.data.type });

            // Directly return the stream object
            return file;

        } catch (err) {
            console.log('There is an Error')
            console.log('error:',err)
            controller.abort();
            return err.response;
        }
    };

    const putMe = async (entity, data, id) => {
        const controller = new AbortController();

        try {
            let url
            //omits the id in the url if it is a setting we are retrieving.
            if (entity.toLowerCase().includes('settings')) {
                url = `api/${entity}`
            } else {
                url = `api/${entity}/${id}`
            }

            const response = await axiosPrivate.put(url, data, {
                signal: controller.signal
            })
            return response.data
        } catch (err) {
            controller.abort()
            return (err.response.data)
        }
    }

    const postMe = async (entity, data) => {
        const controller = new AbortController();
        try {
            const url = `api/${entity}`
            const response = await axiosPrivate.post(url, data)
            return response.data
        } catch (err) {
            controller.abort()
            return (err.response.data)
        }
    }

    const postMeStream = async (entity, data) => {
        const controller = new AbortController();

        try {
            const url = `api/${entity}`;
            const response = await axiosPrivate.post(url, data, {
                signal: controller.signal,
                responseType: 'blob', // Set responseType to 'stream' for handling streams
            });

            const file = new Blob([response.data],
                { type: 'application/pdf' });

            // Directly return the stream object
            return file;
        } catch (err) {
            controller.abort();
            return (err.response.data)
        }
    };


    /**
     * POST that returns a file, honouring whatever the server actually sent.
     *
     * postMeStream cannot be reused for this: it hard-codes application/pdf. Here
     * the content type and the filename come from the response, so one method
     * serves csv, json and whatever format is added next.
     */
    const postMeFile = async (entity, data) => {
        const controller = new AbortController();

        try {
            const url = `api/${entity}`;
            const response = await axiosPrivate.post(url, data, {
                signal: controller.signal,
                responseType: 'blob',
            });

            const mime = response.headers?.['content-type'] || 'application/octet-stream';

            // filename="product-2026-08-26.csv" — quoted or bare.
            const disposition = response.headers?.['content-disposition'] || '';
            const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
            const filename = match ? decodeURIComponent(match[1]) : 'download';

            return {
                file: new Blob([response.data], { type: mime }),
                filename,
                count: Number(response.headers?.['x-export-count']) || null
            };

        } catch (err) {
            controller.abort();

            // The error body is a Blob too, because responseType applies to any
            // status — read it back so the caller gets the server's message
            // rather than "[object Blob]".
            const payload = err.response?.data;
            if (payload instanceof Blob) {
                try {
                    return { error: JSON.parse(await payload.text()) };
                } catch {
                    return { error: { error: 'export.failed' } };
                }
            }
            return { error: payload || { error: 'export.failed' } };
        }
    };

    const postMeForm = async (entity, file, dataItems) => {
        const controller = new AbortController();

        const formData = new FormData();

        //Append the File to formData
        formData.append('file', file);

        // Append each key-value pair from dataItems
        Object.entries(dataItems).forEach(([key, value]) => {
            formData.append(key, value);
        });

        try {
            const url = `api/${entity}`;
            const response = await axiosPrivate.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                signal: controller.signal,
            });

            // Directly return the stream object
            return response;

        } catch (err) {
            controller.abort();
            return (err.response.data)
        }
    };



    const deleteMe = async (entity, id, body = null) => {
        const controller = new AbortController();
        try {
            let url, config
            
            if (body) {
                // For batch operations, entity already includes the full path (e.g., "customerGroup/batch")
                url = `api/${entity}`
                config = {
                    signal: controller.signal,
                    data: body
                }
            } else {
                // For single item deletion
                url = `api/${entity}/${id}`
                config = {
                    signal: controller.signal
                }
            }
            
            const response = await axiosPrivate.delete(url, config)
            return response.data
        } catch (err) {
            controller.abort()
            return (err.response.data)
        }
    }

    return { getMe, putMe, postMe, deleteMe, postMeStream, getMeStream, postMeFile, postMeForm };
}

export default useApi;
